import { render, staticRenderFns } from "./TaskStatusSpan.vue?vue&type=template&id=34ee1f44&scoped=true&"
import script from "./TaskStatusSpan.vue?vue&type=script&lang=js&"
export * from "./TaskStatusSpan.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusSpan.vue?vue&type=style&index=0&id=34ee1f44&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ee1f44",
  null
  
)

export default component.exports